export default "__VITE_ASSET__CNadda3W__"